import classNames from 'classnames'
import { AllCarriersInfoDTO } from 'src/types'

import CustomImage from 'src/components/Image'
import BatchTrack from 'src/components/batch_track'
import useI18n from 'src/hooks/use_i18n'
import styles from './index.module.scss'

// #region component
interface Props {
  h1?: string
  subTitle?: string
  carrier: AllCarriersInfoDTO
  carrierName: string
  country?: string
}

export default function CarriersInfoHeader({ h1, subTitle, carrier, carrierName, country }: Props) {
  const { $t, i18nFormatAll, activeLocale } = useI18n()
  const placeholder =
    activeLocale === 'en'
      ? `Enter up to 40 tracking numbers, one per line; \n Supports airline cargo tracking (e.g. 123-12345678).`
      : `${i18nFormatAll($t('ResGCompYQInput.global.__inputBox_placeholder')?.replace(/。|\./g, ''), ['40'])}.`
  const h1_entry =
    activeLocale === 'tr' ? '{carriersName} Kargo Takip' : $t('ResCarrierListPSeoDetails.global.__pSeoTitleTracking')
  return (
    <>
      <section className={classNames('text-center', styles['carrier-header-box'])}>
        <div className={classNames(styles['carrier-header-content'])}>
          <div className={styles.headerInfo}>
            <div className={styles.logo}>
              <CustomImage
                className="lazyload"
                alt={carrierName}
                isWebp={false}
                width={64}
                height={64}
                src={`https://res.17track.net/asset/carrier/logo/120x120/${Number(carrier.key)}`}
                errorSrc="https://res.17track.net/asset/carrier/logo/120x120/0"
              />
            </div>

            <h1 title={carrierName}>
              {h1 ||
                i18nFormatAll(h1_entry, {
                  carriersName: carrierName
                })}
            </h1>
          </div>

          <p className={styles['yq-carrier-desc']}>
            {subTitle ||
              i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pSubtitleText'), {
                carriersName: carrierName
              })}
          </p>

          <div className={styles['yq-carrier-info']}>
            {carrier._email && (
              <span className={styles['yq-carrier-email']}>
                <i className={classNames('icon fa-envelope')}></i>
                <a
                  className={styles['yq-carrier-email']}
                  title={carrier._email}
                  href={`mailto:${carrier._email}`}
                  rel="nofollow"
                >
                  {carrier._email}
                </a>
              </span>
            )}
            {carrier._tel && (
              <span className={styles['yq-carrier-phoneNumber']}>
                <i className={classNames('icon fa-phone-msg')}></i>
                <a
                  className={styles['yq-carrier-phoneNumber']}
                  title={carrier._tel}
                  href={`tel:${carrier._tel}`}
                  rel="nofollow"
                >
                  {carrier._tel}
                </a>
              </span>
            )}
            <span className={styles['yq-carrier-url']}>
              {carrier._url ? (
                <>
                  <i className={classNames('icon fa-home')}></i>
                  <a href={carrier._url} target="_blank" rel="noopener noreferrer">
                    {carrier._url}
                  </a>
                </>
              ) : (
                $t('ResCarrierList.global.__pageDetail_websiteNull')
              )}
            </span>
          </div>
        </div>
        <div className={classNames('text-left', styles['track-box'])}>
          <div className={classNames(styles['track-content'])}>
            <BatchTrack
              carrierKey={Number(carrier.key)}
              showSidebar={false}
              height={120}
              customPlaceholder={placeholder}
            />
          </div>
        </div>
        {/* 广告位 国内隐藏广告位2024-11-17 */}
        {country === 'CN' ? null : (
          <section className={classNames('ad-slot', styles['gad-container'])} id="V6-Carriers-Main"></section>
        )}
      </section>
    </>
  )
}
